module.exports = __webpack_public_path__ + "img/DK13399174.d05b8b08.png";